export default __webpack_public_path__ + "static/media/content-1-transparent.5b8b4a6f.png";